export const GOODSTACK_EDU_HELP_CENTER_URL = 'https://help.goodstack.org/applying-for-an-education-discount'
